import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsComponent } from './settings/settings.component';



@NgModule({
  declarations: [SettingsComponent],
  imports: [
    CommonModule
  ]
})
export class SettingsModule { }
